const Othello = require('othello-game-logic');
const { ActionCreator, Reducers } = Othello;
const { Reducer } = Reducers;

const AI = {
  isAI:true,
  getNextCell(state, stoneType){
    let next = { cell: null, state: clone(state)};
    next = getMaxScoreCell(state, next.state.gameState);
    return {
      x: next.cell.x,
      y: next.cell.y
    };
  }
}

const getMaxScoreCell = (state: IOthello, stoneType: StoneType): { cell: Cell, state: IOthello} => {
  const myPlaceableCells = state[stoneType].placeableCells;
  let maxScore = Number.MIN_SAFE_INTEGER;

  const next = myPlaceableCells.reduce((prev, cell) => {
    const nextState = Reducer(clone(state), ActionCreator.putStone(cell.x, cell.y, stoneType));
    const nextScore = evaluate(nextState, stoneType);
    if (nextScore > maxScore) {
      maxScore = nextScore;
      return {
        cell,
        state: nextState
      };
    }
    return prev;
  }, { cell: null, state: null});
  return next;
};

const clone = a => JSON.parse(JSON.stringify(a));

const evaluate = (state: IOthello, stoneType: StoneType) => {
  const myBoardScore = getBoardScore(state.board, stoneType);
  const opponentBoardScore = getBoardScore(state.board, opponentType(stoneType));
  const B = myBoardScore - opponentBoardScore;
  const myPlaceableCells = state[stoneType].placeableCells;
  const opponentPlaceableCells = state[opponentType(stoneType)].placeableCells;
  const A = myPlaceableCells.length - opponentPlaceableCells.length;
  const result = A + K * B;
  return result;
};

const K = 1.0;

const opponentType = (stoneType: StoneType) => stoneType === "white" ? "black" : "white";

const BOARD_SCORE_4_DIV = [
  [ 10, -5,  3,  2],
  [ -5, -5,  1,  1],
  [  3,  1,  3,  1],
  [  2,  1,  1,  1]
];

const makeRow = (arr: any[]) => [...arr, ...[...arr].reverse()];

const BOARD_SCORE = makeRow(BOARD_SCORE_4_DIV).map(row => makeRow(row));

const getBoardScore = (board: number[][], stoneType: StoneType) => {
  return stoneType === "black"
      ? calcBoardScore(inversion(board))
      : calcBoardScore(board);
};

const calcBoardScore = (board: number[][]) => {
  let total = 0;
  board.forEach((row, rowIndex) => {
    row.forEach((cell, cellIndex) => {
      const score = BOARD_SCORE[rowIndex][cellIndex];
      total += cell * score;
    });
  });
  return total;
};

const inversion = (board: number[][]) => board.map(row => row.map(cell => cell * -1));

export const AIKawabata = {
  foo: function() {
    return 'プレイヤーですです';
  },
  playerBlack: {
    isAI:true,
    getNextCell(state){
      return AI.getNextCell(state, "black");
    }
  },
  playerWhite: {
    isAI:true,
    getNextCell(state){
      const test = AI.getNextCell(state, "white");
      console.log(test);
      return test;
    }
  }
};
